/**
 * Converts a DT response into a member categories model useful in HCC
 * Categories Meta sections.
 */
import MemberHccCategories from "../../collections/chart-reviews/member-hcc-categories";
import MemberCategories from "../../models/chart-reviews/member-category";

export const createMemberCategories = (dt_response) => {
  if (!dt_response.data) return null;

  const categories = extractCategories(dt_response.data);

  // create a type sorted collection
  const memberHccCategories = new MemberHccCategories(categories);

  return buildMemberCategories(memberHccCategories);
};

const extractCategories = (data) => {
  return data.map((item) => {
    return {
      type: (item.missingIndicator && item.missingIndicator.value) || null,
      name: (item.hccCategory && item.hccCategory.value) || null,
      description:
        (item.hccCategoryDescription && item.hccCategoryDescription.value) ||
        null,
      asOfMonth: (item.asOfMonth && item.asOfMonth.value) || null,
    };
  });
};

const buildMemberCategories = (memberHccCategories) => {
  // output
  let asOfMonth = null;
  const typedTooltips = [];

  // extract unique category types
  const categoryTypes = _.uniq(memberHccCategories.pluck("type"));
  categoryTypes.forEach((type) => {
    // get array of items by type
    const data = memberHccCategories.where({ type });

    asOfMonth = (data[0] && data[0].get("asOfMonth")) || null;

    const value = data.map((category) => category.get("name")).join(", ");

    const tooltip = data.map((category) => {
      return {
        key: category.get("name"),
        value: category.get("description"),
      };
    });

    typedTooltips.push({
      type,
      value,
      tooltip,
    });
  });

  const memberCategories = new MemberCategories({
    asOfMonth,
    data: typedTooltips,
  });

  return memberCategories;
};
